module.exports = __webpack_public_path__ + "static/img/top3.d0d5b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top3.png
// module id = qhYL
// module chunks = 1